import { Component, OnInit } from '@angular/core';
import { faHeart, faSearch } from '@fortawesome/free-solid-svg-icons';
import { faTwitter, faFacebook, faDiscord } from '@fortawesome/free-brands-svg-icons';
@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
    faHeart = faHeart;
    faTwitter = faTwitter;
    faFacebook = faFacebook;
    faDiscord = faDiscord;
    d = new Date();
    footer: any;
    constructor() { }

    ngOnInit(): void {
        this.footer = this.d.getFullYear()
    }

}
